/**
 * The approval form's own check (owner fix, 2026-10-11), before anything is sent: what the approval still lacks,
 * field by field — the same rules as the server's checkDecision, which checks again. A rejection has its own form and
 * is never held up by these fields, and these never ask for a rejection reason.
 */
export type ApproveField = 'memberId' | 'method' | 'note' | 'notDuplicate';
/** In the order the form shows them: the first one missing gets the focus. */
export const APPROVE_FIELDS: ApproveField[] = ['memberId', 'notDuplicate', 'method', 'note'];
export type ApprovalDraft = { mode: 'link' | 'create'; memberId: string | null; method: string; note: string; strong: boolean; notDuplicate: boolean;
  /** Link mode: the preview of what the person will see has loaded (it must be read before approving). */
  previewReady?: boolean };

export function approvalErrors(d: ApprovalDraft): Partial<Record<ApproveField, string>> {
  const e: Partial<Record<ApproveField, string>> = {};
  if (d.mode === 'link' && !d.memberId) e.memberId = 'Velg personen i registeret: søk, eller velg et forslag.';
  else if (d.mode === 'link' && d.previewReady === false) e.memberId = 'Vent til det står hva personen får se, og les det før du godkjenner.';
  if (d.mode === 'create' && d.strong && !d.notDuplicate) e.notDuplicate = 'Bekreft at du har sjekket forslagene og at dette er en annen person.';
  if (!d.method) e.method = 'Velg hvordan du vet at det er riktig person.';
  // A call-back is a basis only with what the call confirmed (member-linking.validate).
  else if (d.method === 'called_back' && !d.note.trim()) e.note = 'Skriv kort hva som ble bekreftet i samtalen.';
  return e;
}
